import defaultPosition from "@/helpers/wc/positionSettings";

export const talkSettings = {
  title: 'Talk',
  name: 'talkBase',
  styles: defaultPosition,
  files: [],

  properties: {
    instructions: 76,
    greetingMessage: 'Velkommen til kvinesdal kommune.\n\nHvilken avdeling �nsker du � snakke med?\n\nDu kan velge: \n{Departments}',
    firewellMessage: 'en ansatt er p� vei til � hjelpe deg.',
    voice: 'nova',
    speed: 0.8,
    fileWaitingSound: 'cb4927c6-ed15-4abd-9fa1-427cf5a846cd.mp3',
    waitingSoundVolume: 0.3,
    repeatWaitingSound: false,
    receptionistId: '',
    receptionistMessage: 'En synshemmet person trenger hjelp',
    sendOnSilent: 1,
    stopOnSilent: 10,
    emailEmployee: false,
    smsEmployee: false,
    employeeMessage: '',
    smsVisitor: false,
    isVisitorMessage: false,
    visitorMessage: [],
    queueLength: 2,
    queueMinutes: 1,
    excludeDepartments: [],
    css: {
      button: {
        color: 'white',
        padding: '5px',
        paddingTop: '5px',
        paddingBottom: '5px',
        backgroundColor: 'rgb(23, 23, 23)',
        borderColor: 'rgb(57, 61, 121)',
        borderWidth: '0px',
        borderRadius: '0px'
      },
      picture: {
        normal: '#00c4ff',
        prompt: '#3dcd3d',
        waiting: 'yellow',
        listen: '#ef1919',
        speak: '#3dcd3d',
        stop: 'hotpink',
        send: 'olive'
      },
      dialog: {
        maxHeight: '300px',
        fontSize: 14,
        fontFamily: "Roboto",
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: '20px',
        borderColor: '#aeb7e2',
        borderWidth: '2px',
        padding: '10px'
      },
      text: {
        user: 'rgba(0, 0, 0, 0)',
        ai: 'rgba(0, 0, 1, 1)',
        sys: 'rgba(0, 0, 0, 1)'
      }
    }
  },
  cssLegend: {
    button: {
      name: 'layout',
      padding: {
        type: 'int',
        name: 'paddingLeftRight',
        handler: val => val + 'px'
      },
      paddingBottom: {
        type: 'int',
        name: 'paddingBottom',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      borderColor: {
        type: 'color',
        name: 'border'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    },
    picture: {
      name: 'iconColor',
      normal: {
        type: 'color',
        name: 'normal'
      },
      waiting: {
        type: 'color',
        name: 'waiting'
      },
      listen: {
        type: 'color',
        name: 'listen'
      },
      speak: {
        type: 'color',
        name: 'speak'
      },
      stop: {
        type: 'color',
        name: 'stop'
      },
      send: {
        type: 'color',
        name: 'wcSend'
      }
    },
    dialog: {
      name: 'dialogBlock',
      maxHeight: {
        type: 'int',
        name: 'maxHeight',
        handler: val => val + 'px'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      textAlign: {
        type: 'align',
        name: 'align'
      },
      backgroundColor: {
        type: 'color',
        name: 'backgroundColor'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      },
      borderColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    },
    text: {
      name: 'wcText',
      user: {
        type: 'color',
        name: 'user'
      },
      ai: {
        type: 'color',
        name: 'ai'
      },
      sys: {
        type: 'color',
        name: 'system'
      }
    }
  }
};
